import { render, staticRenderFns } from "./DealerDualMenu.vue?vue&type=template&id=0177f47a&"
import script from "./DealerDualMenu.vue?vue&type=script&lang=ts&"
export * from "./DealerDualMenu.vue?vue&type=script&lang=ts&"
import style0 from "./DealerDualMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports